<template>
    <DsModalDialog
        v-model="isQuestConfirmOpen"
        css-class="bonusomat-quests-confirm-modal"
        theme="dark"
        :bottom-divider-visible="false"
    >
        <template #top>
            <DsTopSlotHeadlineSubheadline
                :headline="headline"
                :subheadline="description"
                :image-src="headlineImg"
                :image-alt="headlineImgAlt"
            />
        </template>
        <template #bottom>
            <DsBottomSlotActionBar
                theme="dark"
                size="sm"
                btn-submit-type="error"
                :btn-submit-text="btnSubmitText"
                btn-close-text="Storno"
                @submit-dialog="submitHandler"
                @close-dialog="closeModal"
            />
        </template>
    </DsModalDialog>
</template>

<script lang="ts" setup>
import { computed, watch } from "vue";

import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";

import { bonImgUrl } from "../../utils/image-src";

import useBonusomatData from "../../composables/use-bonusomat-data";
import { useStackedModals } from "@sazka/utils/composables/use-stacked-modals";

const { lastActivatedQuestId, isQuestConfirmOpen, isActiveQuestCancelable, activateQuest, deactivateQuest } =
    useBonusomatData();
const { addToStackedModals, removeFromStackedModals } = useStackedModals();

const headline = computed(() =>
    lastActivatedQuestId.value ? "Opravdu chcete aktivovat jiný Quest?" : "Opravdu chcete ukončit Quest?"
);
const headlineImg = computed(() =>
    lastActivatedQuestId.value ? bonImgUrl("board/mr-green", "png") : bonImgUrl("quests/mr-red-cancel-quest", "png")
);
const headlineImgAlt = computed(() =>
    lastActivatedQuestId.value ? "Pan Zelený na černém pozadí" : "Pan Červený na černém pozadí"
);
const description = computed(() =>
    isActiveQuestCancelable.value
        ? "K rozehranému Questu se můžete kdykoliv vrátit."
        : "K " +
          (lastActivatedQuestId.value ? "aktuálně" : "tomuto") +
          " rozehranému Questu se <span style='color: red; font-weight: bold;'>nebudete</span> moct vrátit."
);
const btnSubmitText = computed(() => (lastActivatedQuestId.value ? "Ano, aktivovat" : "Ano, ukončit"));

const closeModal = () => {
    isQuestConfirmOpen.value = false;
};

watch(
    isQuestConfirmOpen,
    (newIsQuestConfirmOpen, oldIsQuestConfirmOpen) => {
        if (newIsQuestConfirmOpen) {
            addToStackedModals();
        } else if (oldIsQuestConfirmOpen) {
            removeFromStackedModals();
        }
    },
    {
        immediate: true,
    }
);

const submitHandler = async () => {
    closeModal();

    if (lastActivatedQuestId.value) {
        await activateQuest(lastActivatedQuestId.value, true);
    } else {
        await deactivateQuest(null, true);
    }
};
</script>
